import Vue from 'vue'
function isSymbolChar(keycode) {
  const numpadKey = keycode <= 105 && keycode >= 96
  const boardTopNumberKey = keycode <= 57 && keycode >= 48
  const isNumberKey = numpadKey || boardTopNumberKey
  const isDotKey = keycode === 190 || keycode === 110
  const isA2Z = keycode >= 65 && keycode <= 90

  return isNumberKey || isDotKey || isA2Z
}

/**
 * keyboard press outside event support
 *
 * Usage:
 *    <div v-keyup-outside="handler">...</div>
 */
Vue.directive('keyup-outside', {
  bind(el, binding) {
    const focus = binding.modifiers.focus
    const fn = binding.value

    if (typeof fn !== 'function') {
      return false
    }

    el.__keyupOutside__ = e => {
      const keyCode = e.keyCode || e.which
      if (
        !el.contains(e.target) &&
        el !== e.target &&
        e.target.nodeName !== 'INPUT' &&
        e.target.nodeName !== 'TEXTAREA' &&
        !e.shiftKey &&
        isSymbolChar(keyCode)
      ) {
        if (!focus) el.focus()
        fn(e)
      }
    }
    document.addEventListener('keyup', el.__keyupOutside__)
  },
  unbind(el, binding) {
    document.removeEventListener('keyup', el.__keyupOutside__)
    el.__keyupOutside__ = null
  }
})
